export const LINC_ONNA_API_DOMAIN = 'asia-northeast3-onna-builder-linc.cloudfunctions.net';
export const HIVE_ONNA_API_DOMAIN = 'asia-northeast3-onna-hive.cloudfunctions.net';
export const DA2UM_ONNA_API_DOMAIN = 'asia-northeast3-onna-builder-da2um.cloudfunctions.net';
export const LINC_API_DOMAIN = 'lincshare.co.kr';
export const DA2UM_API_DOMAIN = 'da2um.kr';
export const HIVE_API_DOMAIN = 'hive2.co.kr';
export const LINC_API_TOKEN = '294305F3C49EDDB41C7ACCA515E8A850';
export const HIVE_API_TOKEN = '294305F3C49EDDB41C7ACCA515E8A850';
export const DA2UM_API_TOKEN = '294305F3C49EDDB41C7ACCA515E8A850'; // Ready Player Me (moved from src/api/config.ts)
export const RPM_API_KEY = 'sk_live_KI59CNWl1hXhZebwfM64ouWAZxEJ0-da_FWA';
export const RPM_APP_ID = '68a413362240338178f06162'; // Temporary until moved server-side: onthewall/getIp cloud function domains
export const GD_VIRTUAL_STAGING_DOMAIN = 'asia-northeast3-gd-virtual-staging.cloudfunctions.net';
export const GD_VIRTUAL_STAGING_US_DOMAIN = 'us-central1-gd-virtual-staging.cloudfunctions.net';
